<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span><el-page-header content="通行证配置" @back="goBack" /></span>
        </div>
        <el-form ref="form" :model="extraData" label-width="80px">
          <el-form-item label="开放等级">
            <el-form :inline="true">
              <el-form-item prop="openLv">
                <el-input v-model.number="extraData.openLv" style="width:200px" />
              </el-form-item>

              <el-form-item label="指引等级" prop="guideLv">
                <el-input v-model.number="extraData.guideLv" style="width:200px" />
              </el-form-item>

              <el-form-item label="初始化经验" prop="passExp">
                <el-input v-model.number="extraData.passExp" style="width:200px" />
              </el-form-item>

              <el-form-item label="最大等级经验差" prop="maxLevelExpGap">
                <el-input v-model.number="extraData.maxLevelExpGap" style="width:200px" />
              </el-form-item>
            </el-form>
          </el-form-item>

          <el-form-item label="图标颜色">
            <el-form :inline="true">
              <el-form-item prop="iconColor">
                <el-input v-model.number="extraData.iconColor" style="width:200px" />
              </el-form-item>

              <el-form-item label="扫光颜色" prop="itemColor">
                <el-input v-model.number="extraData.itemColor" style="width:200px" />
              </el-form-item>
            </el-form>
          </el-form-item>

          <el-form-item>
            <el-card>
              <div slot="header" class="clearfix">
                <span>奖励配置</span>
              </div>
              <el-table :data="stageReward" border stripe>
                <el-table-column prop="extraData" label="等级">
                  <template slot-scope="scope">
                    <el-input v-model.number="scope.row.level" />
                  </template>
                </el-table-column>
                <el-table-column prop="max" label="max">
                  <template slot-scope="scope">
                    <el-input v-model.number="scope.row.max" />
                  </template>
                </el-table-column>
                <el-table-column prop="isGrandPrize" label="是否是大奖">
                  <template slot-scope="scope">
                    <el-select v-model.number="scope.row.isGrandPrize" style="width:150px" placeholder="请选择">
                      <el-option
                        v-for="item in alertStatusType"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      />
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column prop="isFb" label="FB领奖">
                  <template slot-scope="scope">
                    <el-select v-model.number="scope.row.prize.isFb" style="width:150px" placeholder="请选择">
                      <el-option
                        v-for="item in fb"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      />
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column prop="prize" label="免费奖励配置" width="350">
                  <template slot-scope="scope">
                    <ActReward :value="scope.row.prize.prize" />
                  </template>
                </el-table-column>
                <el-table-column prop="specialPrize" label="付费奖励配置" width="350">
                  <template slot-scope="scope">
                    <ActReward :value="scope.row.specialPrize.prize" />
                  </template>
                </el-table-column>
                <el-table-column v-if="type === 'traffic_permit3'" prop="superPrize" label="付费奖励配置2" width="350">
                  <template slot-scope="scope">
                    <ActReward :value="scope.row.superPrize.prize" />
                  </template>
                </el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-button v-permisaction="['config:rewardTrafficPermitEdit:add']" size="mini" type="danger" @click="delLevelReward(scope.$index)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-button v-permisaction="['config:rewardTrafficPermitEdit:add']" style="margin-top: 5px" type="primary" @click="addLevelReward()">+</el-button>
            </el-card>
          </el-form-item>
          <el-form-item>
            <el-card>
              <div slot="header" class="clearfix">
                <span>任务配置-单日</span>
              </div>
              <el-table :data="extraData.task" border stripe>
                <el-table-column prop="id" label="等级">
                  <template slot-scope="scope">
                    <el-input v-model.number="scope.row.id" />
                  </template>
                </el-table-column>
                <el-table-column prop="extraData" label="等级">
                  <template slot-scope="scope">
                    <el-select v-model.number="scope.row.type" placeholder="请选择" @change="(v)=>taskTypeChange(v, 'extraData',scope.$index)">
                      <el-option
                        v-for="item in taskType"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                        :disabled="item.disabled"
                      />
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column prop="num" label="需要完成次数">
                  <template slot-scope="scope">
                    <el-input v-model.number="scope.row.num" />
                  </template>
                </el-table-column>
                <el-table-column prop="getNum" label="可获得经验值">
                  <template slot-scope="scope">
                    <el-input v-model.number="scope.row.getNum" />
                  </template>
                </el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-button v-permisaction="['config:rewardTrafficPermitEdit:add']" size="mini" style="margin-top: 5px" type="danger" @click="delTask(scope.$index)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-button v-permisaction="['config:rewardTrafficPermitEdit:add']" style="margin-top: 5px" type="primary" @click="addTask('extraData')">+</el-button>
            </el-card>
          </el-form-item>
          <el-form-item>
            <el-card>
              <div slot="header" class="clearfix">
                <span>任务配置-双日</span>
              </div>
              <el-table :data="extraReward" border stripe>
                <el-table-column prop="id" label="等级">
                  <template slot-scope="scope">
                    <el-input v-model.number="scope.row.id" />
                  </template>
                </el-table-column>
                <el-table-column prop="extraData" label="等级">
                  <template slot-scope="scope">
                    <el-select v-model.number="scope.row.type" placeholder="请选择" @change="(v)=>taskTypeChange(v, 'extraData',scope.$index)">
                      <el-option
                        v-for="item in taskType"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                        :disabled="item.disabled"
                      />
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column prop="num" label="需要完成次数">
                  <template slot-scope="scope">
                    <el-input v-model.number="scope.row.num" />
                  </template>
                </el-table-column>
                <el-table-column prop="getNum" label="可获得经验值">
                  <template slot-scope="scope">
                    <el-input v-model.number="scope.row.getNum" />
                  </template>
                </el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-button v-permisaction="['config:rewardTrafficPermitEdit:add']" size="mini" style="margin-top: 5px" type="danger" @click="delTask(scope.$index,'extraReward')">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-button v-permisaction="['config:rewardTrafficPermitEdit:add']" style="margin-top: 5px" type="primary" @click="addTask('')">+</el-button>
            </el-card>
          </el-form-item>
          <el-form-item>
            <el-card>
              <div slot="header" class="clearfix">
                <span>免费奖励配置</span>
                <ActReward :value="extraData.maxReward.prize" />
              </div>
              <div slot="header" class="clearfix">
                <span>付费奖励配置</span>
                <ActReward :value="extraData.maxReward.specialPrize" />
              </div>
              <div v-if="type === 'traffic_permit3'" slot="header" class="clearfix">
                <span>付费奖励配置2</span>
                <ActReward :value="extraData.maxReward.superPrize" />
              </div>
            </el-card>
          </el-form-item>
          <el-form-item>
            <el-card>
              <div slot="header" class="clearfix">
                <span>购买配置</span>
              </div>
              <el-form-item label="免费">
                <el-card>
                  <el-form :inline="true">
                    <el-form-item label="价格" style="margin-top: 10px;">
                      <el-select v-model="rewardConf.normal.price" style="width: 100px;" placeholder="请选择" @change="(v)=>{return priceChange(v, 'normal')}">
                        <el-option
                          v-for="(item, index) in shopSku"
                          :key="index"
                          :label="item.label"
                          :value="item.value"
                        />
                      </el-select>
                    </el-form-item>
                    <el-form-item label="库存" style="margin-top: 10px;">
                      <el-input v-model="rewardConf.normal.sku" readonly style="width: 250px;" placeholder="库存" />
                    </el-form-item>
                    <el-form-item label="商品ID" style="margin-top: 10px;">
                      <el-input v-model.number="rewardConf.normal.gid" style="width: 80px;" placeholder="商品ID" />
                    </el-form-item>
                    <el-form-item style="margin-top: 10px;">
                      {{ getRewardList2( rewardConf.normal.rewards) }}
                      <el-button type="text" style="margin-left: 16px;" @click="rewardConfFree[0].visible = true">
                        配置
                      </el-button>
                      <el-drawer
                        title="免费商品配置"
                        size="1050px"
                        :visible.sync="rewardConfFree[0].visible"
                        :direction="direction"
                      >
                        <el-form>
                          <el-row v-for="(r, i) in rewardConf.normal.rewards" :key="i">
                            <el-form-item label="类型" style="margin-top: 10px;">
                              <el-select v-model.number="r.type" style="width: 200px;" placeholder="请选择">
                                <el-option
                                  v-for="(item, index) in rewardType2"
                                  :key="index"
                                  :label="item.label"
                                  :value="item.value"
                                />
                              </el-select>
                            </el-form-item>
                            <el-form-item label="奖品数量" style="margin-top: 10px;">
                              <el-input v-model.number="r.value" style="width: 150px;" placeholder="奖品数量" />
                            </el-form-item>
                            <el-form-item style="margin-top: 10px;">
                              <el-button v-permisaction="['config:rewardCollectEdit:add']" type="danger" @click="removeReward(0, i, 'reward-free' )">删除11</el-button>
                            </el-form-item>
                          </el-row>
                          <el-button v-permisaction="['config:rewardCollectEdit:add']" style="margin-top: 5px" type="primary" @click="addReward(0, 'reward-free' )">+</el-button>
                        </el-form>
                      </el-drawer>
                    </el-form-item>
                  </el-form>
                </el-card>
              </el-form-item>
              <el-form-item label="付费" style="margin-top: 10px">
                <el-card>
                  <el-form :inline="true">
                    <el-form-item label="价格" style="margin-top: 10px;">
                      <el-select v-model="rewardConf.special.price" style="width: 100px;" placeholder="请选择" @change="(v)=>{return priceChange(v, 'special')}">
                        <el-option
                          v-for="(item, index) in shopSku"
                          :key="index"
                          :label="item.label"
                          :value="item.value"
                        />
                      </el-select>
                    </el-form-item>
                    <el-form-item label="库存" style="margin-top: 10px;">
                      <el-input v-model="rewardConf.special.sku" readonly style="width: 250px;" placeholder="库存" />
                    </el-form-item>
                    <el-form-item label="商品ID" style="margin-top: 10px;">
                      <el-input v-model.number="rewardConf.special.gid" style="width: 80px;" placeholder="商品ID" />
                    </el-form-item>
                    <el-form-item style="margin-top: 10px;">
                      {{ getRewardList2( rewardConf.special.rewards) }}
                      <el-button type="text" style="margin-left: 16px;" @click="rewardConfFree[1].visible = true">
                        配置
                      </el-button>
                      <el-drawer
                        title="付费商品配置"
                        size="1050px"
                        :visible.sync="rewardConfFree[1].visible"
                        :direction="direction"
                      >
                        <el-form>
                          <el-row v-for="(r, i) in rewardConf.special.rewards" :key="i">
                            <el-form-item label="类型" style="margin-top: 10px;">
                              <el-select v-model.number="r.type" style="width: 200px;" placeholder="请选择">
                                <el-option
                                  v-for="(item, index) in rewardType2"
                                  :key="index"
                                  :label="item.label"
                                  :value="item.value"
                                />
                              </el-select>
                            </el-form-item>
                            <el-form-item label="奖品数量" style="margin-top: 10px;">
                              <el-input v-model.number="r.value" style="width: 150px;" placeholder="奖品数量" />
                            </el-form-item>
                            <el-form-item style="margin-top: 10px;">
                              <el-button v-permisaction="['config:rewardTrafficPermitEdit:add']" type="danger" @click="removeReward(0, i, 'reward-special' )">删除</el-button>
                            </el-form-item>
                          </el-row>
                          <el-button v-permisaction="['config:rewardTrafficPermitEdit:add']" style="margin-top: 5px" type="primary" @click="addReward(0, 'reward-special' )">+</el-button>
                        </el-form>
                      </el-drawer>
                    </el-form-item>
                  </el-form>
                </el-card>
              </el-form-item>
              <el-form-item v-if="type === 'traffic_permit3'" label="付费2" style="margin-top: 10px">
                <el-card>
                  <el-form :inline="true">
                    <el-form-item label="价格" style="margin-top: 10px;">
                      <el-select v-model="rewardConf.super.price" style="width: 100px;" placeholder="请选择" @change="(v)=>{return priceChange(v, 'super')}">
                        <el-option
                          v-for="(item, index) in shopSku"
                          :key="index"
                          :label="item.label"
                          :value="item.value"
                        />
                      </el-select>
                    </el-form-item>
                    <el-form-item label="库存" style="margin-top: 10px;">
                      <el-input v-model="rewardConf.super.sku" readonly style="width: 250px;" placeholder="库存" />
                    </el-form-item>
                    <el-form-item label="商品ID" style="margin-top: 10px;">
                      <el-input v-model.number="rewardConf.super.gid" style="width: 80px;" placeholder="商品ID" />
                    </el-form-item>
                    <el-form-item style="margin-top: 10px;">
                      {{ getRewardList2( rewardConf.super.rewards) }}
                      <el-button type="text" style="margin-left: 16px;" @click="rewardConfFree[1].visible = true">
                        配置
                      </el-button>
                      <el-drawer
                        title="付费商品配置"
                        size="1050px"
                        :visible.sync="rewardConfFree[1].visible"
                        :direction="direction"
                      >
                        <el-form>
                          <el-row v-for="(r, i) in rewardConf.special.rewards" :key="i">
                            <el-form-item label="类型" style="margin-top: 10px;">
                              <el-select v-model.number="r.type" style="width: 200px;" placeholder="请选择">
                                <el-option
                                  v-for="(item, index) in rewardType2"
                                  :key="index"
                                  :label="item.label"
                                  :value="item.value"
                                />
                              </el-select>
                            </el-form-item>
                            <el-form-item label="奖品数量" style="margin-top: 10px;">
                              <el-input v-model.number="r.value" style="width: 150px;" placeholder="奖品数量" />
                            </el-form-item>
                            <el-form-item style="margin-top: 10px;">
                              <el-button v-permisaction="['config:rewardTrafficPermitEdit:add']" type="danger" @click="removeReward(0, i, 'reward-super' )">删除</el-button>
                            </el-form-item>
                          </el-row>
                          <el-button v-permisaction="['config:rewardTrafficPermitEdit:add']" style="margin-top: 5px" type="primary" @click="addReward(0, 'reward-super' )">+</el-button>
                        </el-form>
                      </el-drawer>
                    </el-form-item>
                  </el-form>
                </el-card>
              </el-form-item>
              <el-form-item label="弹窗配置" style="margin-top: 10px">
                <el-form :inline="true">
                  <el-form-item label="状态" prop="status">
                    <el-select v-model.number="rewardConf.alertConfig.status" placeholder="请选择">
                      <el-option
                        v-for="item in alertStatusType"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      />
                    </el-select>
                  </el-form-item>

                  <el-form-item label="首次阶段" prop="firstStage">
                    <el-input v-model.number="rewardConf.alertConfig.firstStage" style="width:200px" />
                  </el-form-item>

                  <el-form-item label="间隔阶段" prop="intervalStage">
                    <el-input v-model.number="rewardConf.alertConfig.intervalStage" style="width:200px" />
                  </el-form-item>
                </el-form>
              </el-form-item>
            </el-card>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" :disabled="isOnline === 1" @click="onSubmit">保存</el-button>
            <el-button>取消</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import {
  getActivtyStageRewardCfg,
  getTaskTypesList,
  updateTrafficPermitCfg,
  getActivtyList,
  importActivtyRewardCfg,
  exportActivtyRewardCfg,
  getActivtyAllList, getActivityTypeToMap
} from '@/api/config/activity-cfg'
import { getRewardType } from '@/api/config/slot'
import { getSku } from '@/api/config/shop-cfg'
import { getRewardListForType } from '@/utils'
import ActReward from '@/components/Reward/act.vue'

export default {
  name: 'RewardTrafficPermitEdit',
  components: { ActReward },
  data() {
    return {
      isOnline: 0,
      freeReward: [{ visible: false }],
      specialReward: [{ visible: false }],
      superReward: [{ visible: false }],
      rewardConfFree: [{ visible: false }, { visible: false }],
      taskFreeReward: [{ visible: false }, { visible: false }, { visible: false }],
      aid: 0,
      type: '',
      maxRewardType: [{ label: '金币', value: 1 }],
      alertStatusType: [{ label: '关闭', value: 0 }, { label: '开启', value: 1 }],
      fb: [{ label: '是', value: 1 }, { label: '否', value: 0 }],
      extraReward: [
        { id: 1, type: 1, num: 1, getNum: 0, curTaskNum: 0, curSpendSpins: 0 }
      ],
      extraData: {
        openLv: 0,
        upLvDiamondNum: 0,
        guideLv: 0,
        passExp: 0,
        itemColor: '',
        maxLevelExpGap: 0,
        task: [
          { id: 1, type: 1, num: 1, getNum: 0, curTaskNum: 0, curSpendSpins: 0 }
        ],
        maxReward: {
          prize: [],
          specialPrize: [],
          superPrize: [],
          fbPrize: {
            isOpen: 1,
            taskLevel: 1,
            prize: []
          }
        }
      },
      stageReward: [
        { level: 0, max: 0, isGrandPrize: 1, prize: { isFb: 0, prize: {}}, specialPrize: { isFb: 0, prize: {}}, superPrize: { isFb: 0, prize: {}}}
      ],
      rewardConf:
        {
          normal: { price: 0, sku: 0, gid: 1770, rewards: [{
            type: 1,
            value: 1
          }] },
          special: { price: 0, sku: 0, gid: 1814, rewards: [{
            type: 1,
            value: 1
          }] },
          super: { price: 0, sku: 0, gid: 1817, rewards: [{
            type: 1,
            value: 1
          }] },
          alertConfig: {
            status: 0,
            firstStage: 0,
            intervalStage: 0
          }
        },
      direction: 'rtl',
      rewardType: [],
      rewardType2: [{ label: '通行证专属名字颜色', value: 1 }, { label: '通行证专属头像框', value: 2 }, { label: '赠送N个通行证等级', value: 3 }],
      taskType: [],
      taskType2: [],
      shopSku: [],
      activtyToType: [],
      activtyToTypeId: [],
      activtyList: []
    }
  },
  created() {
    this.getShopSkuList()
    this.getTaskTypes()
    this.aid = this.$route.query.id
    this.type = this.$route.query.type
    this.ucType = this.$route.query.uc_type
    this.isOnline = parseInt(this.$route.query.is_online)
    this.typeChange('')
    // this.getActivtyToType()
    // this.getRewardTypeData(1)
    this.getTables()
  },
  methods: {
    getShopSkuList() {
      getSku({ type: 3 }).then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            const val = res.data[i]
            this.shopSku.push({ label: val.price, value: val.price, sku: val.sku })
          }
        } else {
          this.msgError(res.msg)
        }
      })
    },
    goBack() {
      this.$router.push({ path: '/config/activity-config/index' })
    },
    onSubmit() {
      if (this.rewardConf.special.price === 0) {
        this.msgError('购买配置-请选择商品价格')
        return
      }

      if (this.rewardConf.normal.price === 0) {
        this.msgError('购买配置-请选择商品价格')
        return
      }

      if (this.rewardConf.super.price === 0) {
        this.msgError('购买配置-请选择商品价格')
        return
      }

      for (const i in this.extraData.maxReward.prize) {
        const prize = this.extraData.maxReward.prize[i]
        if (prize.type === 65) {
          this.extraData.maxReward.prize[i].num *= 10000
        }
      }

      for (const i in this.extraData.maxReward.superPrize) {
        const prize = this.extraData.maxReward.superPrize[i]
        if (prize.type === 65) {
          this.extraData.maxReward.superPrize[i].num *= 10000
        }
      }

      for (const i in this.extraData.maxReward.specialPrize) {
        const prize = this.extraData.maxReward.specialPrize[i]
        if (prize.type === 65) {
          this.extraData.maxReward.specialPrize[i].num *= 10000
        }
      }

      for (const i in this.extraData.maxReward.fbPrize.prize) {
        const prize = this.extraData.maxReward.fbPrize.prize[i]
        if (prize.type === 65) {
          this.extraData.maxReward.fbPrize.prize[i].num *= 10000
        }
      }

      for (const i in this.stageReward) {
        const stageReward = this.stageReward[i]
        for (const k in stageReward.prize.prize) {
          const p = stageReward.prize.prize[k]
          if (p.type === 65) {
            this.stageReward[i].prize.prize[k].num *= 10000
          }
        }

        for (const k in stageReward.specialPrize.prize) {
          const p = stageReward.specialPrize.prize[k]
          if (p.type === 65) {
            this.stageReward[i].specialPrize.prize[k].num *= 10000
          }
        }
      }

      const data = {
        extraData: this.extraData,
        rewardConfig: this.rewardConf,
        stageReward: this.stageReward,
        extraReward: this.extraReward
      }
      const _data = JSON.stringify(data)
      console.log(_data)
      const postData = { type: this.type, id: this.aid, data: _data }
      // console.log(postData)
      updateTrafficPermitCfg(postData).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables() {
      getActivtyStageRewardCfg({ id: this.aid }).then(res => {
        if (res.code === 200) {
          const stageReward = res.data.reward
          if (stageReward === null) {
            this.stageReward = []
            return
          } else {
            for (const k in stageReward) {
              const val = stageReward[k]
              if (val.prize.prize === null) {
                stageReward[k].prize.prize = []
              }
              if (!val.specialPrize) {
                stageReward[k].specialPrize = { prize: [] }
              }
              if (val.specialPrize.prize === null) {
                stageReward[k].specialPrize.prize = []
              }
              if (!val.superPrize) {
                stageReward[k].superPrize = { prize: [] }
              }
              if (val.superPrize.prize === null) {
                stageReward[k].superPrize.prize = []
              }
            }
          }
          this.stageReward = stageReward
          this.extraReward = res.data.extra_reward
          if (this.extraReward === null) {
            this.extraReward = []
          }

          this.listenTaskType('extraReward')
          if (!this.stageReward) {
            return
          }
          this.stageReward.forEach((r, idx) => {
            for (const rk in r.prize.prize) {
              const p = r.prize.prize[rk]
              if (p.type === 65) {
                this.stageReward[idx].prize.prize[rk].num /= 10000
              }
            }
            for (const rk in r.specialPrize.prize) {
              const p = r.specialPrize.prize[rk]
              if (p.type === 65) {
                this.stageReward[idx].specialPrize.prize[rk].num /= 10000
              }
            }
            this.freeReward.push({ visible: false })
            this.specialReward.push({ visible: false })
            this.superReward.push({ visible: false })
          })
        } else {
          this.msgError(res.msg)
        }
      })
      getActivtyList({ id: this.aid }).then(res => {
        if (res.code === 200) {
          this.extraData = res.data.list[0].extraData
          if (this.extraData === null) {
            // this.extraData = []
            this.extraData = {
              openLv: 0,
              upLvDiamondNum: 0,
              guideLv: 0,
              passExp: 0,
              itemColor: '',
              maxLevelExpGap: 0,
              task: [],
              maxReward: {
                prize: [],
                specialPrize: [],
                superPrize: [],
                fbPrize: {
                  isOpen: 1,
                  taskLevel: 1,
                  prize: []
                }
              }
            }
          }

          if (this.extraData.task === null) {
            this.extraData.task = []
          }

          if (this.extraData.maxReward.prize === null) {
            this.extraData.maxReward.prize = []
          }

          if (this.extraData.maxReward.specialPrize === null) {
            this.extraData.maxReward.specialPrize = []
          }
          if (this.extraData.maxReward.superPrize === null) {
            this.extraData.maxReward.superPrize = []
          }

          if (this.extraData.maxReward.fbPrize.prize === null) {
            this.extraData.maxReward.fbPrize.prize = []
          }

          for (const i in this.extraData.maxReward.prize) {
            const prize = this.extraData.maxReward.prize[i]
            if (prize.type === 65) {
              this.extraData.maxReward.prize[i].num /= 10000
            }
          }

          for (const i in this.extraData.maxReward.specialPrize) {
            const prize = this.extraData.maxReward.specialPrize[i]
            if (prize.type === 65) {
              this.extraData.maxReward.specialPrize[i].num /= 10000
            }
          }

          for (const i in this.extraData.maxReward.fbPrize.prize) {
            const prize = this.extraData.maxReward.fbPrize.prize[i]
            if (prize.type === 65) {
              this.extraData.maxReward.fbPrize.prize[i].num /= 10000
            }
          }
          const rewardConf = res.data.list[0].reward_conf
          if (!rewardConf) {
            return
          }
          if (!rewardConf.normal) {
            rewardConf.normal = { rewards: [] }
          }
          if (rewardConf.normal.rewards === null) {
            rewardConf.normal.rewards = []
          }
          if (rewardConf.special.rewards === null) {
            rewardConf.special.rewards = []
          }
          if (!rewardConf.super) {
            rewardConf.super = { rewards: [] }
          }
          if (rewardConf.super.rewards === null) {
            rewardConf.special.rewards = []
          }
          if (!rewardConf.normal.gid) {
            rewardConf.normal.gid = 1770
          }
          if (!rewardConf.special.gid) {
            rewardConf.special.gid = 1814
          }
          if (!rewardConf.super.gid) {
            rewardConf.super.gid = 1837
          }
          this.rewardConf = rewardConf
          console.log('rewardConf', this.rewardConf)
          this.listenTaskType()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    add() {
      this.listenType()
      let selectType = ''
      this.types.forEach(item => {
        if (!item.disabled) {
          selectType = item.value
        }
      })

      if (!selectType) {
        this.msgError('无可添加类型')
        return
      }
      console.log('可选类型', selectType)
      this.formData.push({ type: selectType, bet: 1 })
      this.listenType()
    },
    del(i) {
      this.formData = this.formData.filter((item, index) => {
        return index !== i
      })
    },
    listenType() {
      this.types.forEach((item, index) => {
        this.types[index].disabled = false
      })
      this.formData.forEach((item, index) => {
        for (const i in this.types) {
          const t = this.types[i]
          if (t.value === item.type) {
            this.types[i].disabled = true
          }
        }
      })
    },
    getRewardTypeData(ucType) {
      getRewardType({ data: ucType }).then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.rewardType.push({ 'label': res.data[i], 'value': parseInt(i) })
          }
        }
      })
    },
    getTaskTypes() {
      getTaskTypesList().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.taskType.push({ 'label': res.data[i], 'value': parseInt(i), disabled: false })
            this.taskType2.push({ 'label': res.data[i], 'value': parseInt(i), disabled: false })
          }
        }
      })
    },
    addReward(index, type) {
      console.log('addReward', type)
      switch (type) {
        case 'free':
          this.extraData.maxReward[index].prize.push({
            id: 0,
            num: 0,
            type: 1,
            rtype: 1,
            is_ts: 0,
            skin: 0,
            ts: 0
          })
          break

        case 'special':
          this.extraData.maxReward[index].specialPrize.push({
            id: 0,
            num: 0,
            type: 1,
            rtype: 1,
            is_ts: 0,
            skin: 0,
            ts: 0
          })
          break

        case 'reward-free':
          this.rewardConf.normal.rewards.push({
            type: 1,
            value: 1
          })
          break

        case 'reward-special':
          this.rewardConf.special.rewards.push({
            type: 1,
            value: 1
          })
          break

        case 'reward-super':
          this.rewardConf.super.rewards.push({
            type: 1,
            value: 1
          })
          break

        case 'stage-free':
          this.stageReward[index].prize.prize.push({
            id: 0,
            num: 0,
            type: 1,
            rtype: 1,
            is_ts: 0,
            skin: 0,
            ts: 0
          })
          break

        case 'stage-special':
          if (this.stageReward[index].specialPrize === null) {
            this.$set(this.stageReward[index], 'specialPrize', { isFb: 0, prize: {}})
          }
          this.stageReward[index].specialPrize.prize.push({
            id: 0,
            num: 0,
            type: 1,
            rtype: 1,
            is_ts: 0,
            skin: 0,
            ts: 0
          })
          break

        case 'task-free':
          if (this.extraData.maxReward.prize === null) {
            this.$set(this.extraData.maxReward, 'prize', [])
          }
          this.extraData.maxReward.prize.push({
            id: 0,
            num: 0,
            type: 1,
            rtype: 1,
            is_ts: 0,
            skin: 0,
            ts: 0
          })
          break

        case 'task-special':
          if (this.extraData.maxReward.specialPrize === null) {
            this.$set(this.extraData.maxReward, 'specialPrize', [])
          }
          this.extraData.maxReward.specialPrize.push({
            id: 0,
            num: 0,
            type: 1,
            rtype: 1,
            is_ts: 0,
            skin: 0,
            ts: 0
          })
          break

        case 'fb-task-special':
          if (this.extraData.maxReward.fbPrize.prize === null) {
            this.$set(this.extraData.maxReward.fbPrize, 'prize', [])
          }
          this.extraData.maxReward.fbPrize.prize.push({
            id: 0,
            num: 0,
            type: 1,
            rtype: 1,
            is_ts: 0,
            skin: 0,
            ts: 0
          })
          break
      }
    },
    removeReward(index, i, type) {
      switch (type) {
        case 'free':
          this.extraData.maxReward[index].prize = this.extraData.maxReward[index].prize.filter((item, key) => {
            return i !== key
          })
          break

        case 'special':
          this.extraData.maxReward[index].specialPrize = this.extraData.maxReward[index].specialPrize.filter((item, key) => {
            return i !== key
          })
          break

        case 'reward-free':
          this.rewardConf.normal.rewards = this.rewardConf.normal.rewards.filter((item, key) => {
            return i !== key
          })
          break

        case 'reward-special':
          this.rewardConf.special.rewards = this.rewardConf.special.rewards.filter((item, key) => {
            return i !== key
          })
          break

        case 'reward-super':
          this.rewardConf.super.rewards = this.rewardConf.super.rewards.filter((item, key) => {
            return i !== key
          })
          break

        case 'stage-free':
          this.stageReward[index].prize.prize = this.stageReward[index].prize.prize.filter((item, key) => {
            return i !== key
          })
          break

        case 'stage-special':
          this.stageReward[index].specialPrize.prize = this.stageReward[index].specialPrize.prize.filter((item, key) => {
            return i !== key
          })
          break

        case 'task-free':
          this.extraData.maxReward.prize = this.extraData.maxReward.prize.filter((item, key) => {
            return i !== key
          })
          break

        case 'task-special':
          this.extraData.maxReward.specialPrize = this.extraData.maxReward.specialPrize.filter((item, key) => {
            return i !== key
          })
          break

        case 'fb-task-special':
          this.extraData.maxReward.fbPrize.prize = this.extraData.maxReward.fbPrize.prize.filter((item, key) => {
            return i !== key
          })
          break
      }
    },
    addLevelReward() {
      const len = this.stageReward.length
      this.stageReward.push({ level: len + 1, max: 0, isGrandPrize: 0, prize: { isFb: 0, prize: [] }, specialPrize: { isFb: 0, prize: [] }, superPrize: { isFb: 0, prize: [] }})
      this.freeReward.push({ visible: false })
      this.specialReward.push({ visible: false })
    },
    delLevelReward(index) {
      this.stageReward = this.stageReward.filter((item, i) => {
        return index !== i
      })
    },
    taskTypeChange(v, type = 'extraData', index) {
      if (type === 'extraData') {
        this.extraData.task[index].id = v
      } else {
        this.extraReward[index].id = v
      }
      this.listenTaskType(type)
    },
    addTask(type = 'extraData') {
      this.listenTaskType(type)
      if (type === 'extraData') {
        if (this.extraData.task === null) {
          this.$set(this.extraData, 'task', [])
        }

        let selectType = 0

        for (const i in this.taskType) {
          const val = this.taskType[i]
          if (!val.disabled) {
            selectType = val.value
            break
          }
        }

        if (selectType === 0) {
          this.msgError('无可用类型')
          return
        }

        this.extraData.task.push({ id: selectType, type: selectType, num: 1, getNum: 0, curTaskNum: 0, curSpendSpins: 0 })
      } else {
        let selectType = 0

        for (const i in this.taskType2) {
          const val = this.taskType2[i]
          if (!val.disabled) {
            selectType = val.value
            break
          }
        }

        if (selectType === 0) {
          this.msgError('无可用类型')
          return
        }

        this.extraReward.push({ id: selectType, type: selectType, num: 1, getNum: 0, curTaskNum: 0, curSpendSpins: 0 })
      }
      this.listenTaskType(type)
    },
    listenTaskType(type = 'extraData') {
      if (type === 'extraData') {
        this.taskType.forEach((item, index) => {
          this.taskType[index].disabled = false
        })

        this.extraData.task.forEach(item => {
          for (const i in this.taskType) {
            const val = this.taskType[i]
            if (val.value === item.type) {
              this.taskType[i].disabled = true
              break
            }
          }
        })
      } else {
        this.taskType2.forEach((item, index) => {
          this.taskType2[index].disabled = false
        })

        this.extraReward.forEach(item => {
          for (const i in this.taskType2) {
            const val = this.taskType2[i]
            if (val.value === item.type) {
              this.taskType2[i].disabled = true
              break
            }
          }
        })
      }
    },
    delTask(index, type = 'extraData') {
      if (type === 'extraData') {
        this.extraData.task = this.extraData.task.filter((item, key) => {
          return key !== index
        })
        // let id = 0
        // this.extraData.task.forEach((item, i) => {
        //   id++
        //   this.extraData.task[i].id = id
        // })
      } else {
        this.extraReward = this.extraReward.filter((item, key) => {
          return key !== index
        })
      }

      this.listenTaskType(type)
    },
    priceChange(v, key) {
      let _sku = ''
      this.shopSku.forEach((item) => {
        if (item.value === v) {
          _sku = item.sku
        }
      })
      this.rewardConf[key].sku = _sku
      console.log(key, _sku)
    },
    importUploadSuccess(response) {
      importActivtyRewardCfg({ type: this.type, id: this.aid, data: response.data.path }).then(res => {
        // eslint-disable-next-line eqeqeq
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    exportData() {
      exportActivtyRewardCfg({ id: this.aid, type: this.type }).then(res => {
        if (res.code === 200) {
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getRewardList(prize) {
      return getRewardListForType(prize, this.rewardType)
    },
    getRewardList2(prize) {
      const arr = []
      for (const i in prize) {
        const val = prize[i]
        for (const k in this.rewardType2) {
          const val2 = this.rewardType2[k]
          if (val.type === val2.value) {
            arr.push(val2.label + '*' + val.value)
            break
          }
        }
      }
      return arr.join(',')
    },
    typeChange(v) {
      // if (this.activtyToTypeId.includes(v)) {
      let typ = ''
      if (v) {
        typ = this.activtyToType[v]
      }
      getActivtyAllList({ type: typ }).then(res => {
        if (res.code === 200) {
          this.activtyList = res.data
        }
      })
    },
    getActivtyToType() {
      getActivityTypeToMap().then(res => {
        if (res.code === 200) {
          this.activtyToType = res.data
          for (const i in res.data) {
            this.activtyToTypeId.push(parseInt(i))
          }
        } else {
          this.msgError(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
